import { render, staticRenderFns } from "./ArquivoRecebido.vue?vue&type=template&id=30cf337f&scoped=true"
import script from "./ArquivoRecebido.vue?vue&type=script&lang=js"
export * from "./ArquivoRecebido.vue?vue&type=script&lang=js"
import style0 from "./ArquivoRecebido.vue?vue&type=style&index=0&id=30cf337f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf337f",
  null
  
)

export default component.exports